import React from 'react'
import { useTranslation } from 'react-i18next'
import { useContact } from '../../context/ContactContext'
import './header.css'
import MEVideo from '../../assets/videoheader.mp4'
import { FiArrowUpRight, FiChevronDown } from 'react-icons/fi'

const Header = () => {
  const { t } = useTranslation()
  const { openContact } = useContact()

  return (
    <header id="home" className="hero">
      <div className="hero__bg">
        <video autoPlay loop playsInline muted src={MEVideo} />
        <div className="hero__overlay" />
        <div className="hero__orb hero__orb--1" />
        <div className="hero__orb hero__orb--2" />
        <div className="hero__orb hero__orb--3" />
        <div className="hero__grid" />
        <div className="hero__spotlight" />
      </div>

      <div className="container hero__layout">
        <div className="hero__main">
          <div className="hero__glow" aria-hidden="true" />

          <div className="hero__badge hero__anim hero__anim--1">
            <span className="hero__badge-dot" />
            {t('hero.badge')}
          </div>

          <h1 className="hero__anim hero__anim--2">
            <span className="hero__title-line">{t('hero.titleLine1')}</span>
            <span className="hero__title-accent">{t('hero.titleLine2')}</span>
          </h1>

          <p className="hero__subtitle hero__anim hero__anim--3">{t('hero.subtitle')}</p>

          <div className="hero__actions hero__anim hero__anim--4">
            <div className="hero__cta">
              <button type="button" className="hero__cta-primary" onClick={openContact}>
                <span>{t('hero.ctaPrimary')}</span>
                <FiArrowUpRight />
              </button>
              <a href="#portfolio" className="hero__cta-secondary">
                {t('hero.ctaSecondary')}
              </a>
            </div>

            <p className="hero__focus" aria-label="Focus areas">
              <span>Web Apps</span>
              <span>Enterprise</span>
              <span>Mobile</span>
              <span>Cloud</span>
            </p>
          </div>

          <a href="#about" className="hero__scroll hero__anim hero__anim--5" aria-label="Scroll down">
            <FiChevronDown />
          </a>
        </div>
      </div>
    </header>
  )
}

export default Header
